import { Directive, HostListener, Inject, Input, OnInit } from '@angular/core';
import { AnimationPlayer, AnimationBuilder, AnimationMetadata, animate, style } from '@angular/animations';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[appButtonFadein]'
})
export class ButtonFadeinDirective implements OnInit {
    // Inicializa o objeto que contém a animação
    player: AnimationPlayer;
    // Variável que diz se o botão toTop está fixo ou não
    toTopButtonIsFixed = true;
    // Variável que diz se o botão toEnd está fixo ou não
    toEndButtonIsFixed = true;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private builder: AnimationBuilder
    ) { }

    ngOnInit() {
        this.playAnimation('toTop', this.fadeOut());
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        // Porcentagem que indica o local que a tela está
        const number = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
        // Topo da página
        if (number < 400) {
            this.pageTop();
            // console.log('teste1');
        } else if (number > 400) { // Fim da página
            this.pageEnd();
            // console.log('teste2');
        }
    }

    // Roda quando a página vem do final para o início
    pageTop() {
        if (!this.toEndButtonIsFixed) {
            this.toEndButtonIsFixed = true;
            this.playAnimation('toEnd', this.fadeIn());
        } else {
            // console.log('botão toEnd fixo');
        }
        if (this.toTopButtonIsFixed) {
            this.toTopButtonIsFixed = false;
            this.playAnimation('toTop', this.fadeOut());
        } else {
            // console.log('botão toTop não fixo');
        }
    }

    // Roda quando a página vem do início para o final
    pageEnd() {
        if (this.toEndButtonIsFixed) {
            this.toEndButtonIsFixed = false;
            this.playAnimation('toEnd', this.fadeOut());
        } else {
            // console.log('botão toEnd não fixo');
        }
        if (!this.toTopButtonIsFixed) {
            this.toTopButtonIsFixed = true;
            this.playAnimation('toTop', this.fadeIn());
        } else {
            // console.log('botão toTop fixo');
        }
    }

    playAnimation(element, metadata) {
        // Cria a animação com o metadata
        const factory = this.builder.build(metadata);
        // Atribui a animação no objeto
        const player = factory.create(this.document.getElementById(element));
        // Roda a animação na tela
        player.play();
    }

    private fadeIn(): AnimationMetadata[] {
        return [
            style({ opacity: 0 }),
            animate('400ms ease-in', style({ opacity: 1, visibility: 'visible' })),
        ];
    }

    private fadeOut(): AnimationMetadata[] {
        return [
            style({ opacity: '*' }),
            animate('400ms ease-in', style({ opacity: 0, visibility: 'hidden' })),
        ];
    }
}
